export function safePublicUrl(value) {
  const url = String(value || '').trim()
  return /^https?:\/\//i.test(url) ? url : ''
}
export function sanitizePublicHtml(value) {
  const template = document.createElement('template')
  template.innerHTML = String(value || '')
  const tags = new Set('P BR DIV SPAN STRONG B EM I U S UL OL LI H1 H2 H3 H4 H5 BLOCKQUOTE PRE CODE TABLE THEAD TBODY TFOOT TR TH TD A IMG VIDEO SOURCE HR'.split(' '))
  const scrub = parent => Array.from(parent.children).forEach(node => {
    if (!tags.has(node.tagName)) { node.remove(); return }
    Array.from(node.attributes).forEach(attr => {
      if (['href', 'src', 'poster'].includes(attr.name)) {
        if (!safePublicUrl(attr.value)) node.removeAttribute(attr.name)
      } else if (!['alt', 'title', 'colspan', 'rowspan', 'controls'].includes(attr.name)) node.removeAttribute(attr.name)
    })
    if (node.tagName === 'A') { node.setAttribute('target', '_blank'); node.setAttribute('rel', 'noopener noreferrer') }
    if (node.tagName === 'VIDEO') node.setAttribute('controls', '')
    scrub(node)
  })
  scrub(template.content)
  return template.innerHTML
}
